import styles from "./CharacterWithBubble.module.scss";
import {Artist} from "../utils/artist.utils";
import rizuko from "../assets/images/riize/character/character_rizuko.png";
import karangi from "../assets/images/aespa/character/character_karangi.png";

type CharacterWithBubbleProps = {
  artist: Artist;
  character: string;
  content: React.ReactNode;
};

const getCharacterImageSrc = (character: string): string => {
  if (character === "karangi") {
    return karangi;
  }
  return rizuko;
};

const CharacterWithBubble = ({
  artist,
  character,
  content,
}: CharacterWithBubbleProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={`${styles.bubble} ${artist}`}>{content}</div>
      {character && (
        <div className={styles.area}>
          <img
            src={getCharacterImageSrc(character)}
            alt=""
            className={styles.image}
          />
        </div>
      )}
    </div>
  );
};

export default CharacterWithBubble;
